import type { SxProps } from '@mui/material';

const styles = {
  titleBox: {
    marginBottom: '0.5rem',
    width: '100%',
    paddingBottom: '0.25rem',
    borderBottom: '3px solid black',
    minHeight: '3.7rem',
  },
};

type TitleBoxProps = {
  children: React.ReactNode;
  sx?: SxProps;
} & React.HTMLAttributes<HTMLDivElement>;

export const TitleBox = ({ children, sx = {}, ...props }: TitleBoxProps) => {
  return (
    <div style={{ ...styles.titleBox, ...sx } as React.CSSProperties} {...props}>
      {children}
    </div>
  );
};
